<template>
    <div class="animated fadeIn">
        <DynamicCardList
                ref="dynamicCardList"
                caption="Liste des établissements"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                root="/branch/list"
                :trash="dataTrash">
        </DynamicCardList>
        <ModalTrash
                ref="trash"
                root="/branch"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'établissement')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet établissement?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicCardList from '../components/DynamicCardList'
    import ModalTrash from '../components/ModalTrash'
    export default {
        name: 'BranchList',
        components: {
            DynamicCardList,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom'),
                        key: 'name',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Adresse'),
                        key: 'address',
                        type: 'text',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Ville'),
                        key: 'city',
                        sortable: true
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'name'
                                        }
                                    ]
                                }
                            ]
                        },
                    ],
                    fields: [
                        {
                            id: 'name',
                            type: 'text',
                            label: Core.Definition.getDefinition('Titre'),
                            value: ''
                        },
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                            value: ''
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataTrash: {
                    show: true,
                    text: '<button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></button>',
                    onClick: this.clickTrash
                }
            }
        },
        methods: {
            clickEdit(value, cell, row) {
                this.$router.push('/systeme/etablissements/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
